import api from 'api/api'
import { toast } from 'react-toastify'
import { urlPdfs } from 'constants/urls'
import { OUTPUT_STATUS } from 'constants/outputs'

export const GET_OUTPUTS = '[OUTPUTS] GET OUTPUTS'
export const GET_OUTPUT_BY_ID = '[OUTPUTS] GET OUTPUT BY ID'
export const RESET_OUTPUT_BY_ID = '[OUTPUTS] RESET OUTPUT BY ID'

export function getOutputsAction(filters = { skipUserId: 0, startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/outputs/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_OUTPUTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_OUTPUTS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_OUTPUTS, error)
    }).finally(() => {
      dispatch({ type: GET_OUTPUTS, payload: { loading: false } })
    })
  }
}

export function getOutputByIdAction(outputId) {
  const request = api.get(`/output/${outputId}`)
  return (dispatch) => {
    dispatch({ type: GET_OUTPUT_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_OUTPUT_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_OUTPUT_BY_ID, error)
    }).finally(() => {
      dispatch({ type: GET_OUTPUT_BY_ID, payload: { loading: false } })
    })
  }
}